import z from 'zod'
import constants from '../../constants'
import { ReimbursementType } from '../enums/ReimbursementType.enum'
import ZodHelper from '../../helpers/zod.helper'
import { Currency } from '../enums/Currency.enum'
import { ApprovalStatus } from '../enums/ApprovalStatus.enum'

const MAX_FILE_SIZE = constants.limits.maxLeaveRequestFileUploadSize

const medicalReimbursementCreateSchema = z
  .object({
    approvalStatus: ZodHelper.zEnumFromTsEnum(ApprovalStatus),
    name: z.string().min(2),
    email: z.email(),
    serviceDate: z.date(),
    reimbursementType: ZodHelper.zEnumFromTsEnum(ReimbursementType),
    vendor: z.string().min(2),
    description: z.string().nullish(),
    totalAmountClaimed: z.object({
      currency: ZodHelper.zEnumFromTsEnum(Currency),
      value: z
        .string()
        .refine(val => !!val && !isNaN(Number(val)), {
          message: 'Please input number only value...',
        })
        .refine(val => Number(val) > constants.limits.minMedicalReimbursementAmount, {
          message: 'Minimum value of 1...',
        }),
    }),
    supportingDocument: z
      .instanceof(File)
      .refine(file => file.size <= MAX_FILE_SIZE, {
        message: `Max image size is ${Intl.NumberFormat().format(MAX_FILE_SIZE / (1024 * 1024 * 1024))}GB.`,
      })
      .nullish(),
  })
  .refine(data => data.supportingDocument !== null, {
    message: 'Please upload your supporting document...',
    path: ['supportingDocument'],
  })

export type MedicalReimbursementCreateSchema = z.infer<typeof medicalReimbursementCreateSchema>

export default medicalReimbursementCreateSchema
